import { Icon, IconProps } from '@chakra-ui/react'

export default function BellNotificationIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5024 17.3609C18.5498 17.3609 19.3998 16.5135 19.4031 15.4661V15.4661V15.4661C19.4025 14.9331 19.1897 14.4224 18.8119 14.0465L17.5524 12.786V9.04141C17.5521 7.56957 16.9668 6.15819 15.9254 5.1181C14.884 4.07801 13.4719 3.49451 12.0001 3.4961V3.4961C8.93848 3.49776 6.4573 5.97983 6.45675 9.04141V12.783L5.19723 14.0435C4.8191 14.4192 4.60602 14.93 4.60498 15.4631V15.4631V15.4631C4.60829 16.5105 5.45833 17.3579 6.50577 17.3579L17.5024 17.3609Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5205 20.5041H13.4787"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
